// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__xR2Of","opacity":"Tooltip_opacity__fiQZ1"};